import { css } from '@lastbrand/web-ui-styled-system/css'

// Native <button> reset so legacy Button-atom rem SCSS can't balloon under panda.
const sizeChartButtonBaseRaw = css.raw({
  display: 'block',
  width: 'fit-content',
  margin: 0,
  padding: 0,
  cursor: 'pointer',
  appearance: 'none',
  background: 'transparent',
  border: 'none',
  borderBottom: '1px solid token(colors.black)',
  borderRadius: 'radius-none',
  textAlign: 'left',
  textDecoration: 'none',
  color: 'black',
  // STRFRNT-16780/16898: Figma ButtonText md = 12px type at all breakpoints (code: body-12).
  textStyle: 'body-12',
})

export const sizeChartButtonDsClass = css(sizeChartButtonBaseRaw)

export const sizeChartButtonStandaloneDsClass = css(sizeChartButtonBaseRaw, {
  marginBlock: 'space-24',
  marginInline: 0,
})
